import axios from "axios";
import { TTP_API_URL } from "Config";
import { throwCatchedError, updateSourceToken } from "Utils";

let getPelletsSourceToken;
export const getPellets = ({
  token,
  limit,
  communityId,
  offset = 0,
  sourceToken = null,
  currentId = null
}) => {
  getPelletsSourceToken = updateSourceToken(getPelletsSourceToken, sourceToken);

  const requestUrl = `${TTP_API_URL}/organization/folder`;
  //const requestUrl = "http://dev2.api.tamtam.pro/organization/folder";

  const fields = ["id", "uen", "name", "abbreviation", "btbStats"];

  let filter = [];
  if (currentId) {
    filter.push({
      property: "id",
      value: currentId,
      operator: "eq"
    });
  }

  const sort = [
    {
      property: "btbStatsSignature",
      dir: "desc"
    }
  ];
  let params = {
    access_token: token,
    //access_token: "004cb879a81927c7739b1d8d1706adc6a789aa28",
    applyFolderRoleFilter: true,
    sort: JSON.stringify(sort),
    fields: fields.join(","),
    start: offset,
    limit
  };

  if (!currentId) {
    params.organization_id = communityId;
  } else {
    params.filter = JSON.stringify(filter);
  }
  return axios
    .get(requestUrl, {
      cancelToken: getPelletsSourceToken && getPelletsSourceToken.token,
      params
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};



// WEBPACK FOOTER //
// ./src/api/pellet.js